import { getCustomUnitFormat } from './locale';

export enum ByteUnit {
  B = 'byte',
  KB = 'kilobyte',
  MB = 'megabyte',
  GB = 'gigabyte',
  AUTO = 'auto',
}

export const localizeByteUnit = (value = 0, unit = ByteUnit.KB, locale?: string) =>
  getCustomUnitFormat(unit, 'short', locale).format(value);
